import React from 'react';
import DashboardSummary from '../components/dashboard/DashboardSummary';
import CategoryBreakdownChart from '../components/dashboard/CategoryBreakdownChart';
import LowStockItems from '../components/dashboard/LowStockItems';
import RecentTransactions from '../components/dashboard/RecentTransactions';
import AuditTrailWidget from '../components/dashboard/AuditTrailWidget';
import OrdersOverview from '../components/dashboard/OrdersOverview';
import RecentOrders from '../components/dashboard/RecentOrders';
import WeOweAlertBanner from '../components/dashboard/WeOweAlertBanner';
import WeOweWidget from '../components/dashboard/WeOweWidget';
import WarrantiesWidget from '../components/dashboard/WarrantiesWidget';

const DashboardPage: React.FC = () => {
  return (
    <div className="space-y-6 min-h-screen">
      {/* Hero Banner */}
      <div className="overflow-hidden rounded-lg">
        <div className="relative">
          <img
            src="https://images.pexels.com/photos/159888/pexels-photo-159888.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt="Business dashboard with analytics charts and performance metrics"
            className="w-full h-64 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30 flex items-center">
            <div className="px-8 text-white">
              <h1 className="text-3xl font-bold mb-2">Dashboard</h1>
              <p className="text-lg opacity-90">
                Welcome to your comprehensive supplies and products management system
              </p>
              <div className="mt-4 flex items-center space-x-6 text-sm">
                <div className="flex items-center">
                  <span>Real-time Analytics</span>
                </div>
                <div className="flex items-center">
                  <span>Supplies & Manufacturing</span>
                </div>
                <div className="flex items-center">
                  <span>Last Updated: {new Date().toLocaleString()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <WeOweAlertBanner />

      <DashboardSummary />
      
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Orders & Operations</h2>
        <OrdersOverview />
      </div>
      
      {/* Main Dashboard Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 auto-rows-fr">
        {/* Left Column */}
        <div className="space-y-6 lg:col-span-1">
          <CategoryBreakdownChart />
        </div>
        
        {/* Middle Column */}
        <div className="space-y-6 lg:col-span-1">
          <LowStockItems />
        </div>
        
        {/* Right Column */}
        <div className="space-y-6 lg:col-span-2 xl:col-span-1">
          <RecentOrders />
        </div>
      </div>
      
      {/* Bottom Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 auto-rows-fr">
        <div className="lg:col-span-1">
          <RecentTransactions />
        </div>
        <div className="lg:col-span-1">
          <AuditTrailWidget />
        </div>
        <div className="lg:col-span-1">
          <WeOweWidget />
        </div>
        <div className="lg:col-span-1">
          <WarrantiesWidget />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;